export const yr2025 = {
    zelfstandigenaftrek: 2470,
    startersaftrek: 2123,
    mkbVrijstelling: 12.70,
    zvwBijdrage: { pct: 5.26, limit: 75865 },
    arbeidskorting: [
        { low: 0, high: 12170, pct: 8.053, addition: 0 },
        { low: 12170, high: 26289, pct: 30.030, addition: 980 },
        { low: 26289, high: 43072, pct: 2.258, addition: 5220 },
        { low: 43072, high: 129079, pct: -6.510, addition: 5599 },
        { low: 129079, high: 999999999, pct: 0, addition: 0 }
    ],
    belasting: [
        { low: 0, high: 38442, pct: 35.82, addition: 0 },
        { low: 38442, high: 76818, pct: 37.48, addition: 13769 },
        { low: 76818, high: 999999999, pct: 49.50, addition: 28152 },
    ],
    heffingskorting: [
        { low: 0, high: 28407, pct: 0, addition: 3068 },
        { low: 28407, high: 76818, pct: -6.337, addition: 3068 },
        { low: 76818, high: 999999999, pct: 0, addition: 0 },
    ],
    inkomenhoogsteschaal: 76817,
    tarrifaanpassing: 0.1202,
}